import { useEffect } from 'react';
import { atom, useSetAtom } from 'jotai';
import { useLocation } from 'react-router-dom';
import { Box, Divider, List } from '@mui/material';
import { GraphicEq, GridView, MarkChatUnreadOutlined, PeopleAltOutlined, WebOutlined } from '@mui/icons-material';

import { SIDEBAR_WIDTH } from '@/styles/constant';
import AdminMenuItem from '@/components/admin/AdminMenuItem';

import type { MenuItemData } from '@/@types/types';

export const selectedAdminMenuAtom = atom(window.location.pathname);
const menuItems: MenuItemData[] = [
  {
    text: '메인 관리',
    icon: <GridView fontSize="small" sx={{ rotate: '45deg', translate: '2px 0' }} />,
    path: '/admin/main',
    child: [
      { text: '공지사항 관리', icon: null, path: '/admin/main/notice' },
      { text: '이용약관 관리', icon: null, path: '/admin/main/terms' },
      { text: '개인정보처리방침 관리', icon: null, path: '/admin/main/privacy' },
    ],
  },
  {
    text: '회원 관리',
    icon: <PeopleAltOutlined />,
    path: '/admin/users',
    child: [
      { text: '회원 조회', icon: null, path: '/admin/users/view' },
      { text: '탈퇴회원 조회', icon: null, path: '/admin/users/leaved' },
    ],
  },
  {
    text: '사이트 관리',
    icon: <WebOutlined />,
    path: '/admin/sites',
    child: [
      { text: '사이트 조회', icon: null, path: '/admin/sites/view' },
      { text: '멤버 관리', icon: null, path: '/admin/sites/members' },
    ],
  },
  {
    text: '디바이스 관리',
    icon: <GraphicEq />,
    path: '/admin/devices',
    child: [
      { text: '센서 관리', icon: null, path: '/admin/devices/sensors' },
      { text: '게이트웨이 관리', icon: null, path: '/admin/devices/gateways' },
    ],
  },
  {
    text: '알림 관리',
    icon: <MarkChatUnreadOutlined />,
    path: '/admin/notifications',
    child: [
      { text: 'PUSH 발송 관리', icon: null, path: '/admin/notifications/push' },
      { text: '템플릿 관리', icon: null, path: '/admin/notifications/templates' },
    ],
  },
];

export default function Sidebar() {
  const setSelectedMenu = useSetAtom(selectedAdminMenuAtom);
  const location = useLocation();

  useEffect(() => {
    setSelectedMenu(location.pathname);
  }, [location.pathname, setSelectedMenu]);

  return (
    <Box
      sx={{
        flexShrink: 0,
        width: SIDEBAR_WIDTH,
        height: '100%',
        borderRight: 1,
        borderColor: 'divider',
      }}
    >
      <List disablePadding>
        {menuItems.map((item) => (
          <AdminMenuItem key={item.path} item={item} />
        ))}

        <Divider />
      </List>
    </Box>
  );
}
